import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './documents.reducer';
import { DocumentsData } from '../statements/statements.models';
import { DocumentsFilter } from './documents.models';

export const selectDocumentsState = createFeatureSelector<State>('documents');

export const selectDocumentsLoading = createSelector(selectDocumentsState, (state: State) => state.loading);

export const selectDocuments = createSelector(selectDocumentsState, (state: State) => state.documents);

export const selectDocumentsData = createSelector(selectDocuments, (state: DocumentsData) => state.data);

export const selectDocumentsTotal = createSelector(selectDocuments, (state: DocumentsData) => state.total);

export const selectDocumentsFilter = createSelector(selectDocumentsState, (state: State) => state.filter);

export const selectDocumentsFilterType = createSelector(selectDocumentsFilter, (state: DocumentsFilter) => state.type);

export const selectDocumentsFilterFrom = createSelector(selectDocumentsFilter, (state: DocumentsFilter) => state.from);

export const selectDocumentsFilterTo = createSelector(selectDocumentsFilter, (state: DocumentsFilter) => state.to);

export const selectDocumentsSort = createSelector(selectDocumentsState, (state: State) => state.sort);

export const selectDocumentsPagination = createSelector(selectDocumentsState, (state: State) => state.pagination);

export const selectDocumentsMobileState = createSelector(selectDocumentsState, (state: State) => state.mobile);

export const selectDocumentsMobileData = createSelector(selectDocumentsMobileState, (state: DocumentsData) => state.data);

export const selectDocumentsMobilePagination = createSelector(selectDocumentsState, (state: State) => state.mobilePagination);
